import { useEffect, useState } from "react";
import NavAdmin from "../../components/nav-admin/NavAdmin";
import theme from "../../theme";
import WrapperAdmin from "../admin/Admin.styles";
import { styled } from 'styled-components';
import { getActualPriceOfHighlight, getDocumentsByMonthAndYear, getAllDocuments } from "../../hooks/firebase";
import Switch from 'react-ios-switch';

const WrapperCard = styled.div`
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    .card-title {
        font-size: 20px;
        color: white;
    }

    .content {
        width: 60%;
        background-color: white;
        text-align: center;
        color: black;
        font-size: 30px;
        padding: 10% 20%;
        border-radius: 30px;
        font-family: ${theme.fontFamily.bold};
    }
`;

const WrapperCard2 = styled.div`
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    .card-title {
        font-size: 20px;
        color: white;
    }

    .content {
        width: 80%;
        background-color: white;
        text-align: center;
        color: black;
        font-size: 18px;
        padding: 15% 10%;
        border-radius: 30px;
        font-family: ${theme.fontFamily.bold};

        .line {
            display: flex;
            justify-content: space-between;
            width: 100%;
            white-space: nowrap;
        }

        .city-name {
            flex-grow: 1;
            text-align: left;
        }

        .dots {
            flex-grow: 2;
            text-align: center;
            overflow: hidden;
        }

        .city-count {
            flex-grow: 1;
            text-align: right;
        }
    }
`;

const WrapperCard3 = styled.div`
    width: 63%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    margin-top: 20px;

    .card-title {
        font-size: 20px;
        color: white;
    }

    .content {
        width: 80%;
        background-color: white;
        text-align: center;
        color: black;
        font-size: 18px;
        padding: 50px 10%;
        border-radius: 30px;
        font-family: ${theme.fontFamily.bold};

        .line {
            display: flex;
            justify-content: space-between;
            width: 100%;
            white-space: nowrap;
        }

        .city-name {
            flex-grow: 1;
            text-align: left;
        }

        .dots {
            flex-grow: 2;
            text-align: center;
            overflow: hidden;
        }

        .city-count {
            flex-grow: 1;
            text-align: right;
        }
    }
`;

const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 10px;

    .filter-label {
        font-size: 14px;
        color: white;
    }

    .date-filters {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;

const AdminHome = () => {
    const today = new Date();
    const months = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);
    const currentMonth = months[today.getMonth()];
    const currentYear = today.getFullYear();
    const [month, setMonth] = useState(currentMonth); 
    const [year, setYear] = useState(currentYear);
    const [showAll, setShowAll] = useState(false);
    const [freeCountDeleted, setFreeCountDeleted] = useState(0);
    const [freeCountActive, setFreeCountActive] = useState(0);
    const [freeCountStoped, setFreeCountStoped] = useState(0);
    const [highlightCountDeleted, setHighlightCountDeleted] = useState(0);
    const [highlightCountStoped, setHighlightCountStoped] = useState(0);
    const [highlightCountActive, setHighlightCountActive] = useState(0);
    const [highligthPrice, setHighlightPrice] = useState(null);
    const [topCities, setTopCities] = useState(null);
    const [topCategories, setTopCategories] = useState(null);

    function topCidades(imoveis) {
        const contagem = {};
    
        imoveis.forEach(imovel => {
            if (imovel.city) {
                const cidade = imovel.city;
                contagem[cidade] = (contagem[cidade] || 0) + 1;
            }
        });
    
        const cidadesOrdenadas = Object.entries(contagem)
            .sort((a, b) => b[1] - a[1]) 
            .slice(0, 10); 
    
        return cidadesOrdenadas;
    }

    function topCategorias(imoveis) {
        const contagem = {};
    
        imoveis.forEach(imovel => {
            if (imovel.type) {
                const cidade = imovel.type;
                contagem[cidade] = (contagem[cidade] || 0) + 1;
            }
        });
    
        const cidadesOrdenadas = Object.entries(contagem)
            .sort((a, b) => b[1] - a[1]) 
            .slice(0, 10); 
    
        return cidadesOrdenadas;
    }

    useEffect(() => {
        const fetchData = async () => {
            const actualPriceHighlight = await getActualPriceOfHighlight() / 100;
            let result;
            
            if (showAll) {
                result = await getAllDocuments();
            } else {
                const monthNumber = months.indexOf(month) + 1;
                result = await getDocumentsByMonthAndYear(monthNumber, year);
            }

            let highlightdeleted = 0;
            let highlightstoped = 0;
            let highlightactive = 0;
            let propertyHigh = [];
         
            result.forEach(property => {
                if (!property.hasFree) {
                    if (property.deletedAt !== null) highlightdeleted += 1;
                    if (!property.active && property.status !== "ACTIVE") highlightstoped += 1;
                    if (property.status === "PENDING") highlightstoped += 1;
                    if (!property.active) highlightstoped += 1;
                    if (property.active && property.status === "ACTIVE") highlightactive += 1;
                    propertyHigh.push(property);
                }
            });
    
            // Multiplicando pelo preço
            const highlightDeletedInReais = highlightdeleted * actualPriceHighlight;
            const highlightStopedInReais = highlightstoped * actualPriceHighlight;
            const highlightActiveInReais = highlightactive * actualPriceHighlight;
    
            // Formatando para o formato monetário (R$)
            const formatToBRL = (value) => {
                return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
            };
    
            // Atualizando o estado com os valores formatados
            setHighlightPrice(actualPriceHighlight);
            setTopCategories(topCategorias(propertyHigh));
            setTopCities(topCidades(propertyHigh));
            setHighlightCountDeleted(formatToBRL(highlightDeletedInReais));
            setHighlightCountStoped(formatToBRL(highlightStopedInReais));
            setHighlightCountActive(formatToBRL(highlightActiveInReais));
        };

        fetchData();
    }, [month, year, showAll]);

    return (
        <WrapperAdmin>
            <NavAdmin />
            <div className="main">
                <span className="header">
                    <span className="title">Receitas</span>
                    <FilterContainer>
                        {showAll ? 
                            <span className="filter-label">Todos</span>
                            :
                            ""
                        }
                        <Switch
                            checked={!showAll}
                            onChange={() => setShowAll(!showAll)}
                            onColor={theme.fontColor.green}
                            offColor="#E5E5EA"
                        />
                        {!showAll && (
                            <>
                                <span className="filter-label">Filtrar</span>
                                <div className="date-filters">
                                    <select value={month} onChange={(e) => setMonth(e.target.value)}>
                                        {months.map((m) => (
                                            <option key={m} value={m}>{m}</option>
                                        ))}
                                    </select>
                                    /
                                    <select value={year} onChange={(e) => setYear(e.target.value)}>
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        )}
                    </FilterContainer>
                </span>
                <div className="body">
                    <WrapperCard>
                        <span className="card-title">Anúncios excluídos grátis</span>
                        <div className="content">
                            {freeCountDeleted}
                        </div>
                    </WrapperCard>
                    <WrapperCard>
                        <span className="card-title">Anúncios Ativos grátis</span>
                        <div className="content">
                            {freeCountActive}
                        </div>
                    </WrapperCard>
                    <WrapperCard>
                        <span className="card-title">Anúncios Pausados grátis</span>
                        <div className="content">
                            {freeCountStoped}
                        </div>
                    </WrapperCard>
                    <WrapperCard>
                        <span className="card-title">Anúncios Turbinados excluídos</span>
                        <div className="content">
                            {highlightCountDeleted}
                        </div>
                    </WrapperCard>
                    <WrapperCard>
                        <span className="card-title">Anúncios Turbinados Pausados</span>
                        <div className="content">
                            {highlightCountStoped}
                        </div>
                    </WrapperCard>
                    <WrapperCard>
                        <span className="card-title">Anúncios Turbinados Ativos</span>
                        <div className="content">
                            {highlightCountActive}
                        </div>
                    </WrapperCard>
                    <WrapperCard2>
                        <span className="card-title">Região anúncios turbinados</span>
                        <div className="content">
                            {topCities !== null && topCities.map(city => {
                                return (
                                    <span className="line" key={city[0]}>
                                        <span className="city-name">{city[0]}</span>
                                        <span className="dots">..........................................</span>
                                        <span className="city-count">{city[1]}</span>
                                    </span>
                                );
                            })}
                        </div>
                    </WrapperCard2>
                    <WrapperCard3>
                        <span className="card-title">Categorias anúncios turbinados</span>
                        <div className="content">
                            {topCategories !== null && topCategories.map(categorie => {
                                return (
                                    <span className="line" key={categorie[0]}>
                                        <span className="city-name">{categorie[0]}</span>
                                        <span className="dots">...............................................................................................................</span>
                                        <span className="city-count">
                                            {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(categorie[1] * highligthPrice)}
                                        </span>
                                    </span>
                                );
                            })}
                        </div>
                    </WrapperCard3>
                </div>
            </div>
        </WrapperAdmin>
    );
};

export default AdminHome;